import {
  EMPTY_OVERVIEW,
  EMPTY_PAGINATION,
  type DelayedJobsState,
  type DelayedJobRecord,
  type OverviewPayload,
  type Pagination,
  type TabId
} from "../types";
import {
  APPLY_FILTERS,
  CHANGE_PAGE,
  CHANGE_TAB,
  CLOSE_JOB,
  FETCH_DATA_SUCCESS,
  FETCH_JOB_SUCCESS,
  SET_ACTION_PENDING,
  SET_ERROR,
  SET_JOB_CLASS_INPUT,
  SET_LOADING,
  SET_QUEUES_INPUT
} from "./delayedJobsSagas";

export const initialState: DelayedJobsState = {
  activeTab: "overview",
  queuesInput: "",
  jobClassInput: "",
  appliedQueues: "",
  appliedJobClass: "",
  page: 1,
  overview: EMPTY_OVERVIEW,
  records: [],
  pagination: EMPTY_PAGINATION,
  isLoading: true,
  actionPending: false,
  error: null,
  selectedJob: null
};

type Action =
  | { type: typeof CHANGE_TAB; payload: TabId }
  | { type: typeof SET_QUEUES_INPUT; payload: string }
  | { type: typeof SET_JOB_CLASS_INPUT; payload: string }
  | { type: typeof APPLY_FILTERS }
  | { type: typeof CHANGE_PAGE; payload: number }
  | {
      type: typeof FETCH_DATA_SUCCESS;
      payload: { overview: OverviewPayload; records: DelayedJobRecord[]; pagination: Pagination };
    }
  | { type: typeof FETCH_JOB_SUCCESS; payload: DelayedJobRecord }
  | { type: typeof CLOSE_JOB }
  | { type: typeof SET_LOADING; payload: boolean }
  | { type: typeof SET_ACTION_PENDING; payload: boolean }
  | { type: typeof SET_ERROR; payload: string | null };

export default function delayedJobsReducer(
  state: DelayedJobsState = initialState,
  action: Action
): DelayedJobsState {
  switch (action.type) {
    case CHANGE_TAB:
      return {
        ...state,
        activeTab: action.payload,
        page: 1,
        selectedJob: null,
        error: null
      };
    case SET_QUEUES_INPUT:
      return { ...state, queuesInput: action.payload };
    case SET_JOB_CLASS_INPUT:
      return { ...state, jobClassInput: action.payload };
    case APPLY_FILTERS:
      return {
        ...state,
        appliedQueues: state.queuesInput.trim(),
        appliedJobClass: state.jobClassInput.trim(),
        page: 1,
        selectedJob: null
      };
    case CHANGE_PAGE:
      return { ...state, page: action.payload, selectedJob: null };
    case FETCH_DATA_SUCCESS: {
      const pagination = action.payload.pagination || EMPTY_PAGINATION;
      return {
        ...state,
        overview: action.payload.overview || EMPTY_OVERVIEW,
        records: action.payload.records || [],
        pagination,
        // Keep local page in sync when the API clamps an out-of-range request.
        page: pagination.page || state.page,
        isLoading: false,
        actionPending: false
      };
    }
    case FETCH_JOB_SUCCESS:
      return { ...state, selectedJob: action.payload, error: null };
    case CLOSE_JOB:
      return { ...state, selectedJob: null };
    case SET_LOADING:
      return { ...state, isLoading: action.payload };
    case SET_ACTION_PENDING:
      return { ...state, actionPending: action.payload };
    case SET_ERROR:
      return { ...state, error: action.payload, isLoading: false, actionPending: false };
    default:
      return state;
  }
}
